import {observable, computed, action, autorun} from 'mobx';
import firebase from 'firebase';
import {firebaseAuth, onAuthStateChanged} from 'store/FirebaseStore';

import {notFoundRoute, authenticateRoute, loginRoute, notAuthorisedRoute} from 'routes';

const initialUser = {
  displayName: null,
  email: null,
  photoURL: null,
  uid: null,
  groups: {},
  authenticated: false
};

class ViewStore {
  @observable loggingIn = false;
  @observable currentUser = observable.map({});
  router = null;
  layoutStore = null;

  constructor(router, layout) {
    this.router = router;
    this.layoutStore = layout;

    action(() => this.loggingIn = true)();
    onAuthStateChanged(this.setUser);

    // Close the Drawer when the route changes and the Drawer is not docked
    autorun(() => this.toggleSidebarOnNavigate(this.router.activeRoute));
  }

  @computed get currentRoute() {
    if (!this.isLoggedIn) {
      return loginRoute;
    } else if (!this.isAuthenticated) {
      return authenticateRoute;
    } else if (!this.isAuthorised) {
      return notAuthorisedRoute;
    } else {
      return this.router.activeRoute || notFoundRoute;
    }
  }

  @computed get isLoggedIn() {
    return this.currentUser.has('uid');
  }

  @computed get isAuthenticated() {
    return this.currentUser.get('authenticated');
  }

  @computed get isAuthorised() {
    const route = this.router.activeRoute;

    // No matching route found, allow access to notFoundRoute
    if (!route) return true;

    // If route has no access restrictions, allow access
    if (!route.access) return true;

    if (this.currentUser.has('groups')) {
      const groups = this.currentUser.get('groups');

      // Allow any routes if the current user is a developer
      if (groups.developer) return true;

      // Allow access if user has the right group
      return !!route.access.find(item => item in groups);
    }

    // None of the tests passed, dont authorise
    return false;
  }

  @action setUser = (user) => {
    console.log('setUser', {user});
    this.loggingIn = false;
    user
      ? Object.keys(user).forEach(key => this.currentUser.set(key, user[key]))
      : this.currentUser.clear();
  };

  @action signIn = () => {
    this.loggingIn = true;
    this.authenticate();
  };

  @action signOut = () => {
    firebaseAuth.signOut();
  };

  @action authenticate = () => {
    firebaseAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .catch(action(() => this.loggingIn = false));
  };

  @action userHasGroup = groups => {
    return Object.keys(this.currentUser.get('groups')).some(group => groups.includes(group));
  };

  @action toggleSidebarOnNavigate = () => {
    if (!this.layoutStore.sideBarDocked && this.layoutStore.sideBarOpen) {
      this.layoutStore.toggleSideBarOpen();
    }
  };
}

export default ViewStore;



// WEBPACK FOOTER //
// ./src/store/ViewStore.js